"use client";
import {Link} from '@/lib/target';
import React, { lazy } from "react";
const BangkeoAllLeague = lazy(() => import('@/components/client/BangkeoAllLeague'));
const NoDataWithLink = lazy(() => import('@/components/client/NoDataWithLink'));

const BangkeoLiveMatches = ({ matches }) => {
  const liveMatches = matches?.filter((match) => [1, 2, 3, 4, 5].includes(Number(match.status)))

  if (!liveMatches.length) {
    return (
      <NoDataWithLink>
        <span>
          Hôm nay chưa có trận đấu Trực Tuyến nào. Khám phá thêm các trận qua
          Lịch thi đấu
          {
            <Link
              className="text-medium-blue hover:cursor-pointer"
              href={"/lich-thi-dau"}
            >
              &nbsp;tại đây.
            </Link>
          }
        </span>
      </NoDataWithLink>
    );
  }

  return liveMatches.map((match, index) => (
    <BangkeoAllLeague
      type="tc"
      key={index}
      match={match}
    />
  ));
};

export default BangkeoLiveMatches;
